import axios from "axios";

const publicApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

export const fetchReadingList = async (params) => {
  try {
    const cleaned = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null && v !== undefined)
    );
    const res = await publicApi.get("/public/reading", { params: cleaned });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchReadingById = async (id) => {
  try {
    const res = await publicApi.get(`/public/reading/${id}`);
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchPublicCategories = async () => {
  try {
    const res = await publicApi.get("/public/reading/categories");
    return res.data || [];
  } catch {
    return [];
  }
};

export const fetchPublicDifficulties = async () => {
  try {
    const res = await publicApi.get("/public/reading/difficulties");
    return res.data || [];
  } catch {
    return [];
  }
};
